import { lineHeightForSize, remForSize } from '../../../utils';
const buttonBase = {
    _disabled: {
        color: 'button.disabled',
        cursor: 'not-allowed',
        opacity: 1
    },
    borderRadius: 'full',
    cursor: 'pointer',
    fontFamily: 'body',
    letterSpacing: 'normal',
    textStyle: 'button'
};
export const Button = {
    baseStyle: buttonBase,
    variants: {
        primary: {
            _active: {
                bg: 'button.primary.pressed'
            },
            _disabled: {
                color: 'text.inverse',
                bg: 'button.disabled'
            },
            _focusVisible: {
                boxShadow: 'var(--chakra-colors-electricBlue-100) 0px 0px 0px 4px'
            },
            _hover: {
                _disabled: {
                    bg: 'button.disabled'
                },
                bg: 'button.primary.hover',
                textDecoration: 'none'
            },
            _pressed: {
                bg: 'button.primary.pressed'
            },
            bg: 'button.primary.enabled',
            color: 'text.inverse',
            transition: 'background-size 250ms ease-in-out'
        },
        secondary: {
            _active: {
                bg: 'button.secondary.pressed',
                color: 'text.inverse'
            },
            _disabled: {
                color: 'text.inverse',
                bg: 'button.disabled'
            },
            _focusVisible: {
                boxShadow: 'var(--chakra-colors-purple-100) 0px 0px 0px 4px'
            },
            _hover: {
                _disabled: {
                    bg: 'button.disabled',
                    color: 'text.inverse'
                },
                bg: 'button.secondary.hover',
                color: 'text.inverse',
                textDecoration: 'none'
            },
            _pressed: {
                bg: 'button.secondary.pressed'
            },
            bg: 'button.secondary.enabled',
            border: '1px solid var(--chakra-colors-stroke-interactive)',
            color: 'link.link'
        },
        tertiary: {
            _focusVisible: {
                boxShadow: 'none',
                textDecoration: 'underline'
            },
            _hover: {
                _disabled: {
                    color: 'button.disabled'
                },
                color: 'link.hover'
            },
            bg: 'transparent',
            border: 'none',
            color: 'link.link',
            p: 0
        },
        switch: {
            _checked: {
                _disabled: {
                    bg: 'button.disabled',
                    color: 'text.inverse'
                }
            }
        }
    },
    sizes: {
        s: {
            fontSize: remForSize('m'),
            fontWeight: 'semibold',
            h: 'min-content',
            lineHeight: lineHeightForSize('m'),
            px: 3,
            py: 1
        },
        l: {
            fontSize: remForSize('l'),
            fontWeight: 'semibold',
            h: 'min-content',
            lineHeight: lineHeightForSize('l'),
            px: 5,
            py: 1.5
        }
    },
    defaultProps: {
        variant: 'primary',
        size: 'l'
    }
};

//# sourceMappingURL=button.js.map